import { Typography } from 'antd'

import { OpenResourceCardTask } from '@/Core/Tasks/Resources/OpenResourceCardTask'

import { OWNER_RESOURCES } from '../Contracts/Activity.types'
import { relationUuidOf } from '../Helpers/ownerContact'

import type { ActivityOwnerKind, ActivityRecord, ActivityRelationRef } from '../Contracts/Activity.types'

/** Власник справи з запису: клієнт або перевізник і його вид. */
export const activityOwnerOf = (
    record: Pick<ActivityRecord, 'client' | 'carrier'> | null | undefined
): { kind: ActivityOwnerKind; ref: ActivityRelationRef } | null => {
    if (record?.client && relationUuidOf(record.client) !== null) return { kind: 'client', ref: record.client }
    if (record?.carrier && relationUuidOf(record.carrier) !== null) return { kind: 'carrier', ref: record.carrier }

    return null
}

interface Props {
    kind: ActivityOwnerKind
    owner: ActivityRelationRef
}

/**
 * Назва власника — посиланням на його картку (`SPEC-011` §8.1 Р7, §8.4 К-8):
 * картка відкривається другою шухлядою поверх списку чи справи, як у
 * легасі (`ActivityCrud.jsx:88-115`).
 *
 * Клік не доходить до рядка таблиці: інакше разом із власником відкрилася б і
 * сама справа.
 */
export const ActivityOwnerLink = ({ kind, owner }: Props) => {
    const uuid = relationUuidOf(owner)
    const title = typeof owner.title === 'string' && owner.title !== '' ? owner.title : '—'

    if (uuid === null) return <>{title}</>

    return (
        <Typography.Link
            onClick={(event) => {
                event.stopPropagation()
                OpenResourceCardTask({
                    resource: OWNER_RESOURCES[kind].owner,
                    mode: 'view',
                    displayMode: 'drawer',
                    primaryFieldValue: uuid,
                })
            }}
            onDoubleClick={(event) => event.stopPropagation()}
        >
            {title}
        </Typography.Link>
    )
}
